import Category from '@/models/Category';
import Tag from '@/models/Tag';
import * as Yup from 'yup';

export interface QuizForm {
    mainImage?: string;
    name: string;
    author: string;
    description?: string;
    locale: string;
    categories: Category[];
    tags: Tag[];
}

export const quizSchema: Yup.ObjectSchema<QuizForm> = Yup.object().shape<QuizForm>({
    mainImage: Yup.string().required(),
    name: Yup.string().required(),
    author: Yup.string().required(),
    description: Yup.string().notRequired(),
    locale: Yup.string().required(),
    categories: Yup.array<Category>().min(1),
    tags: Yup.array<Tag>().min(1),
});

export const formInitialState = {
    mainImage: '',
    name: '',
    author: '',
    description: '',
    locale: '',
    categories: [],
    tags: [],
};
